module.exports = __webpack_public_path__ + "static/media/NIFTY_F2.77fce278.txt";